import React, { useRef, useState } from "react";
import rainfallimg from "../assets/img/rainfall_img.png";
import homeIcon from "../assets/icons/thinkIcons/Home.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import rainyImg from "../assets/img/imageRainfall2.png";
import sunnyImg from "../assets/img/sunnyIMG.jpg";

const RainfallPredict = () => {
  const [humidity, setHumidity] = useState();
  const [devPoint, setdevPoint] = useState();
  const [cloudClover, setCloudClover] = useState();
  const [sunshine, setSunshine] = useState();
  const [winddirection, setWindDirection] = useState();
  const [windspeed, setWindSpeed] = useState();
  const [pressure, setPressure] = useState(1021.3);
  const [predictionResult, setPredictionResult] = useState(null);
  const [inputData, setInputData] = useState({});
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const resultRef = useRef(null);

  const handlePrediction = async () => {
    // All fields in one object
    const payload = {
      pressure,
      dewpoint: devPoint,
      humidity,
      cloud: cloudClover,
      sunshine,
      winddirection,
      windspeed,
    };

    // Check if any field is missing or empty
    for (let [key, value] of Object.entries(payload)) {
      if (value === "" || value === null || value === undefined) {
        toast.error(
          `${key.charAt(0).toUpperCase() + key.slice(1)} is required`,
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
        return; // stop here if validation fails
      }
    }
    setLoading(true);

    const endpoint = "/rainfall_prediction";

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}${endpoint}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setPredictionResult(res.data.prediction);
      setInputData(res.data.input);

      // Scroll down after data is set
      setTimeout(() => {
        resultRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } catch (error) {
      console.error("Prediction API Error:", error);
      toast.error("Something went wrong while predicting rainfall", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-2 md:p-8 lg:p-12">
      {/* Header Row */}
      <div className="flex justify-end">
        <button
          className="flex items-center gap-2 border  px-3 py-2 rounded-full cursor-pointer"
          onClick={() => navigate("/user/dashboard")}
        >
          <img src={homeIcon} className="w-[18px] h-[18px]" />
          <span className="text-xs">Home</span>
        </button>
      </div>

      {/* Top Card */}
      <div className="border-1 rounded-md mt-2 md:mt-4 flex p-2 md:p-3 gap-4  border-blue-custom">
        <img
          src={rainfallimg}
          alt="Advisory Tool"
          className="w-full max-w-[200px] min-w-[160px] h-[120px] object-cover rounded-md"
        />
        <div className="">
          <h2 className="textcolor font-semibold text-xl">
            Rainfall Prediction
          </h2>
          <p className="textsec text-sm">
            Predict rainfall with confidence, for better planning and decisions.
          </p>
        </div>
      </div>

      {/* Description */}
      <div className="desc-Text border-l-4 border-l-desc-Text pl-4 mt-4 text-lg font-semibold">
        <p className="font-medium m-0">
          Enter the weather parameters to predict the rainfall
        </p>
      </div>

      <form className="my-2 sm:my-4 py-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="">
          <label className="block textblack text-sm font-semibold mb-1 ">
            Pressure (hPa)
          </label>
          <input
            type="range"
            min="950"
            max="1050"
            // placeholder="Enter value"
            value={pressure}
            // onChange={(e) => setPressure(parseFloat(e.target.value))}
            onChange={(e) => {
              let value = parseFloat(e.target.value);
              if (isNaN(value)) {
                setPressure(950);
              } else {
                if (value < 950) value = 950;
                if (value > 1050) value = 1050;
                setPressure(value);
              }
            }}
            className="w-full"
          />
          <div className="text-sm textsec mt-1">{pressure.toFixed(2)}</div>
        </div>

        <div>
          <label className="block textblack text-sm font-semibold mb-1">
            Humidity (%)
          </label>
          <input
            type="number"
            min="0"
            max="100"
            placeholder="Enter value between 0 to 100"
            value={humidity}
            onChange={(e) => {
              let value = parseFloat(e.target.value);
              if (isNaN(value)) {
                setHumidity("");
              } else {
                if (value < 0) value = 0;
                if (value > 100) value = 100;
                setHumidity(value);
              }
            }}
            className="w-full rounded-xl p-3 border-1 border-blue-custom h-[56px] sm:h-[62px]"
          />
        </div>

        <div>
          <label className="block textblack text-sm font-semibold mb-1">
            Dew Point (°C)
          </label>
          <input
            type="number"
            placeholder="Enter value between 0 to 25"
            min="0"
            max="25"
            value={devPoint}
            // onChange={(e) => setdevPoint(parseFloat(e.target.value))}
            onChange={(e) => {
              let value = parseFloat(e.target.value);
              if (isNaN(value)) {
                setdevPoint("");
              } else {
                if (value < 0) value = 0;
                if (value > 25) value = 25;
                setdevPoint(value);
              }
            }}
            className="w-full rounded-xl p-3 border-1 border-blue-custom h-[56px] sm:h-[62px]"
          />
        </div>

        <div>
          <label className="block textblack text-sm font-semibold mb-1">
            Cloud Cover (%)
          </label>
          <input
            type="number"
            placeholder="Enter value between 0 to 100"
            min="0"
            max="100"
            value={cloudClover}
            // onChange={(e) => setCloudClover(parseFloat(e.target.value))}
            onChange={(e) => {
              let value = parseFloat(e.target.value);
              if (isNaN(value)) {
                setCloudClover("");
              } else {
                if (value < 0) value = 0;
                if (value > 100) value = 100;
                setCloudClover(value);
              }
            }}
            className="w-full rounded-xl p-3 border-1 border-blue-custom h-[56px] sm:h-[62px]"
          />
        </div>

        <div>
          <label className="block textblack text-sm font-semibold mb-1">
            Sunshine Duration (Hrs)
          </label>
          <input
            type="number"
            min="0"
            placeholder="Enter value between 0 to 12"
            max="12"
            value={sunshine}
            // onChange={(e) => setSunshine(parseFloat(e.target.value))}
            onChange={(e) => {
              let value = parseFloat(e.target.value);
              if (isNaN(value)) {
                setSunshine("");
              } else {
                if (value < 0) value = 0;
                if (value > 12) value = 12;
                setSunshine(value);
              }
            }}
            className="w-full rounded-xl p-3 border-1 border-blue-custom h-[56px] sm:h-[62px]"
          />
        </div>

        <div>
          <label className="block textblack text-sm font-semibold mb-1">
            Wind Direction (°)
          </label>
          <input
            type="number"
            min="0"
            placeholder="Enter value between 0 to 360"
            max="360"
            value={winddirection}
            // onChange={(e) => setWindDirection(parseFloat(e.target.value))}
            onChange={(e) => {
              let value = parseFloat(e.target.value);
              if (isNaN(value)) {
                setWindDirection("");
              } else {
                if (value < 0) value = 0;
                if (value > 360) value = 360;
                setWindDirection(value);
              }
            }}
            className="w-full rounded-xl p-3 border-1 border-blue-custom h-[56px] sm:h-[62px]"
          />
        </div>

        <div>
          <label className="block textblack text-sm font-semibold mb-1">
            Wind Speed (km/h)
          </label>
          <input
            type="number"
            min="0"
            max="60"
            value={windspeed}
            placeholder="Enter value between 0 to 60"
            // onChange={(e) => setWindSpeed(parseFloat(e.target.value))}
            onChange={(e) => {
              let value = parseFloat(e.target.value);
              if (isNaN(value)) {
                setWindSpeed("");
              } else {
                if (value < 0) value = 0;
                if (value > 60) value = 60;
                setWindSpeed(value);
              }
            }}
            className="w-full rounded-xl p-3 border-1 border-blue-custom h-[56px] sm:h-[62px]"
          />
        </div>
      </form>

      {/* Button */}
      <div className="mt-8 flex justify-center">
        <button
          onClick={handlePrediction}
          disabled={loading}
          className="bgbtn1 textwhite px-6 py-2 rounded shadow hover:bg-[#1376c2] transition"
        >
          {loading ? "Processing..." : "Predict Weather"}
        </button>
      </div>

      {predictionResult && (
        <div className="border-1 border-blue-custom rounded-lg mt-4 p-3 md:p-8 lg:p-12">
          <div className="mb-6">
            <h2 className="text-xl font-semibold textprimary">
              Weather Condition of your Location
            </h2>
            <p className="textsec">
              Predict weather conditions with precision for every scenario.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-lg font-semibold textcolor mb-2">
              Prediction Result
            </h3>

            <div className=" ">
              <div className="relative">
                <img
                  src={predictionResult === "Rainfall" ? rainyImg : sunnyImg}
                  alt="Rainfall prediction"
                  className="w-full h-40 object-cover object-center"
                />

                <div
                  className="absolute top-2 left-2 textcolor font-medium px-4 py-1 rounded shadow"
                  style={{
                    background:
                      "linear-gradient(to right, #71B7EE 5%, white 5%)",
                  }}
                >
                  Predicted Weather:
                  {predictionResult ? predictionResult : "N/A"}
                </div>
              </div>
              <p className="text-xs textsec p-2">
                Note: The image displayed is a generic placeholder for the
                predicted weather type.
              </p>
            </div>
          </div>

          <div ref={resultRef}>
            <h4 className="text-md font-semibold textprimary mb-3">
              Input Data (Preprocessed & Scaled)
            </h4>
            <div className="overflow-x-auto ">
              <table className="min-w-full text-center text-sm rounded-xl border-blue-custom px-4 py-2">
                <thead className="textcolor ">
                  <tr>
                    <th className=" px-4 py-2 border-1">Pressure</th>
                    <th className="border-1 px-4 py-2">Humidity</th>
                    <th className="border-1 px-4 py-2">Dew Point</th>
                    <th className="border-1 px-4 py-2">Cloud Cover</th>
                    <th className="border-1 px-4 py-2">Sunshine</th>
                    <th className="border-1 px-4 py-2">Wind Dir</th>
                    <th className="border-1 px-4 py-2">Wind Speed</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="text-gray-800">
                    <td className="border-1 px-4 py-2">
                      {inputData.pressure ?? "--"}
                    </td>
                    <td className="border-1 px-4 py-2">
                      {inputData.humidity ?? "--"}
                    </td>
                    <td className="border-1 px-4 py-2">
                      {inputData.dewpoint ?? "--"}
                    </td>
                    <td className="border-1 px-4 py-2">
                      {inputData.cloud ?? "--"}
                    </td>
                    <td className="border-1 px-4 py-2">
                      {inputData.sunshine ?? "--"}
                    </td>
                    <td className="border-1 px-4 py-2">
                      {inputData.winddirection ?? "--"}
                    </td>
                    <td className="border-1 px-4 py-2">
                      {inputData.windspeed ?? "--"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RainfallPredict;
